import {
  Component,
  Input,
  OnInit,
  ViewChild
} from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { DeviceAlertItemsModalComponent } from '../device-alert-items-modal/device-alert-items-modal.component';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { XdrService } from 'src/app/shared/services/xdr.service';

/* ======================================================
 * TYPES
 * ====================================================== */

export interface AlertRow {
  timestamp: string
  state: string
  items: [string, number][]
}

/* ======================================================
 * COMPONENT
 * ====================================================== */

@Component({
  selector: 'app-device-alert-xdr',
  templateUrl: './device-alert-xdr.component.html',
  styleUrls: ['./device-alert-xdr.component.scss']
})
export class DeviceAlertXdrComponent implements OnInit {

  @Input() selfSort = false

  private _device: any
  @Input() set deviceInfo(obj: any) {
    if (obj) {
      this._device = obj
      this.page = 0
      this.loadData()
    }
  }

  displayedColumns: string[] = ['Timestamp', 'State', 'Items']
  _dataSource = new MatTableDataSource<AlertRow>([])

  // Feed mapping (label → value)
  xdrFeedLabel: Record<string, 'attack' | 'spam' | 'geoip' | 'dnswatch'> = {
    'Attack': 'attack',
    'Spam': 'spam',
    'GeoIP': 'geoip',
    'DNS Watch': 'dnswatch'
  }

  selectedFeed: 'attack' | 'spam' | 'geoip' | 'dnswatch' = 'attack'
  selectedRange: '4h' | '24h' | '7d' | 'thisMonth' | 'lastMonth' = '4h'

  page = 1
  pageSize = 10
  length = 0
  pageSizeOptions = [5, 10, 25, 100]
  loading = false

  @ViewChild(MatPaginator) paginator!: MatPaginator
  @ViewChild(MatSort) sort!: MatSort

  constructor(private xdrService: XdrService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {}

  // ngAfterViewInit(): void {
  //   this._dataSource.paginator = this.paginator
  //   this._dataSource.sort = this.sort
  // }

  /* ======================================================
   * TABS
   * ====================================================== */

  selectedTabChange(event: MatTabChangeEvent): void {
    const label = event.tab.textLabel

    const feed = this.xdrFeedLabel[label]
    if (feed) this.selectedFeed = feed

    switch (label) {
      case 'Last 4 Hrs': this.selectedRange = '4h'; break
      case 'Last 24 Hrs': this.selectedRange = '24h'; break
      case 'Last 7 Days': this.selectedRange = '7d'; break
      case 'This Month': this.selectedRange = 'thisMonth'; break
      case 'Last Month': this.selectedRange = 'lastMonth'; break
    }

    this.page = 0
    this.loadData()
  }

  getStateClass(state: string): string {
    switch (state) {
      case 'Safe':
        return 'badge-safe';
      case 'Warning':
        return 'badge-warning';
      case 'Recovering':
        return 'badge-recovering';
      default:
        return '';
    }
  }

  openItemsModal(items: [string, number][]): void {
    this.dialog.open(DeviceAlertItemsModalComponent, {
      width: '600px',
      data: { items }
    })
  }


  /* ======================================================
   * PAGINATION
   * ====================================================== */

  handlePageEvent(event: PageEvent): void {
    this.page = event.pageIndex + 1
    this.pageSize = event.pageSize
    this.loadData()
  }

  /* ======================================================
   * API
   * ====================================================== */

  loadData(): void {
    if (!this._device?.[0]?._id) return

    this.loading = true

    this.xdrService.getAlertsByFeed(
      this._device[0]._id,
      this.selectedFeed,
      this.selectedRange,
      this.page,
      this.pageSize
    ).subscribe({
      next: res => {
        const rows: AlertRow[] = (res.data || []).map((h: any) => ({
          timestamp: new Date(h.t * 1000).toLocaleString(),
          state: h.state,
          items: h.items || []
        }))

        this._dataSource.data = rows
        this.length = res?.pagination?.total || rows.length
        // this.page = res.pagination.page;
        // this.pageSize = res.pagination.pageSize;
        this.loading = false
      },
      error: () => {
        this._dataSource.data = []
        this.length = 0
        this.loading = false
      }
    })
  }

  /* ======================================================
   * HELPERS
   * ====================================================== */

  getTopItems(items: [string, number][], limit = 10) {
    return items.slice(0, limit)
  }
}
